<div class="d-flex h-100">
    <div class="d-flex flex-column flex-grow-1">
        <div [ngClass]="{ 'container--sticky': selectedTab === 'COMMUNICATION' }">
            <ul class="nav nav-pills nav-justified">
                <!-- @TODO: Ignored manually on 2023-10-13 -->
                <!-- eslint-disable @angular-eslint/template/use-track-by-function -->
                @for (tab of reservationsTabs; track tab) {
                    <li (click)="selectTab(tab)" class="nav-item mf-pointer font-weight-bold" [ngClass]="{ active: selectedTab === tab }">
                        <a class="nav-link h-100 font--small">{{ tab | tabTypeString | uppercase }}</a>
                    </li>
                }
                <!-- eslint-enable -->
            </ul>
        </div>
        <div class="component_container flex-grow-1">
            @switch (selectedTab) {
                @case ('STATUS') {
                    <res-reservation-status [reservationDetails]="reservationDetails"></res-reservation-status>
                }
                @case ('REFERRAL') {
                    <res-reservation-documents
                        [reservationDetails]="reservationDetails"
                        [documentType]="'REFERRAL'"
                        class="h-100"
                    ></res-reservation-documents>
                }
                @case ('REPORT') {
                    <res-reservation-documents
                        [reservationDetails]="reservationDetails"
                        [documentType]="'REPORT'"
                        class="h-100"
                    ></res-reservation-documents>
                }
                @case ('COMMUNICATION') {
                    <res-reservation-comm [reservationDetails]="reservationDetails"></res-reservation-comm>
                }
            }
        </div>
    </div>
</div>
